var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClocknew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56641 15.1011C10.8801 15.1011 13.5664 12.4997 13.5664 9.29077C13.5664 6.08183 10.8801 3.48047 7.56641 3.48047C4.2527 3.48047 1.56641 6.08183 1.56641 9.29077C1.56641 12.4997 4.2527 15.1011 7.56641 15.1011Z",
    stroke: "#E9A5F3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56641 9.29042L10.2664 6.67578",
    stroke: "#E9A5F3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92969 1.36719H9.20241",
    stroke: "#E9A5F3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClocknew);
export default __webpack_public_path__ + "static/media/clocknew.cdc9bbee11d3063849357777561cf4c9.svg";
export { ForwardRef as ReactComponent };